import { cva } from 'class-variance-authority';

export const stepper = cva('flex flex-col', {
  variants: {
    spacing: {
      default: 'space-y-xl',
      compact: 'space-y-m',
      loose: 'space-y-xxl',
    },
  },
  defaultVariants: {
    spacing: 'default',
  },
});

export const stepperContent = cva('pt-xl pb-xxxl', {
  variants: {
    spacing: {
      default: 'space-y-xl',
      compact: 'space-y-m',
      loose: 'space-y-xxl',
    },
  },
  defaultVariants: {
    spacing: 'default',
  },
});

export const stepperItem = cva('flex flex-row space-x-s');
